import { useNavigate } from 'react-router-dom';
import logo from '../../pe-logo.svg';

export default function PageNotFound() {
    const navigate = useNavigate();
    return (
        <div className="bg-[#FFFFFF] dark:bg-[#262C2C] mx-auto h-[100vh] text-black dark:text-white">
            <div className="grid place-items-center px-6 py-24 sm:py-32 lg:px-8 h-full">
                <div className="text-center">
                    <p className="text-4xl ibm-plex-regular font-semibold text-black dark:text-white pb-10 flex justify-center">
                        <img src={logo} alt="logo" className="pe-logo" />
                    </p>
                    <h1 className="mt-4 text-5xl font-semibold sm:text-7xl text-black dark:text-white">
                        Page not found
                    </h1>
                    <p className="mt-6 lato-regular text-lg font-medium sm:text-xl/8 text-black dark:text-white">
                        Sorry, we couldn’t find the page you’re looking for.
                    </p>
                    <div className="mt-10 flex items-center justify-center gap-x-6">
                        <button
                            className="dark-button"
                            onClick={() => {
                                navigate('/');
                            }}
                        >
                            Go back home
                        </button>
                        <a
                            href="mailto:support@photoengineers.com"
                            className="text-sm font-semibold text-black dark:text-white"
                        >
                            Contact support{' '}
                            <span aria-hidden="true">&rarr;</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
